import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Actions from "../../redux/action";
import Placeholder from "../../asset/images/img.jpg";
import cloneDeep from "lodash.clonedeep";
import { toast } from "react-toastify";
import ModalPopup from "../../component/ModalPopup";
import { getRandomNumber } from "../../Utility/Utils";
export class customerInstructionPopup extends React.Component {
    constructor(props) {
        super(props);
        const cartProductInfo = props?.getPimCartDetails?.pimCart?.products
            ?.reverse()
            .find(
                (cartDetailsProductList) =>
                    cartDetailsProductList.sku === props.productInfo.sku
            );
        const cartInfo = cartProductInfo?.selectedAddOns;
        const subInfo = cartProductInfo?.substitutionListDto;
        const getSelctedAddons = cartInfo?.reduce((previous, current) => {
            previous.push(current.upc);
            return previous;
        }, []);
        const getSelctedSub = subInfo?.reduce((previous, current) => {
            previous.push({ baseIngredientSku: current?.baseIngredientSku, substituteIngredientSku: current?.substituteIngredientSku });
            return previous;
        }, []);
        this.state = {
            checkedItemsIds: getSelctedAddons || [],
            checkedIds: getSelctedSub || [],
            isUpdateProduct: !!cartInfo,
            bistroNotes: ""
        };
    }

    onChangeCheckbox(details) {
        const { productInfo } = this.props;
        const { addOnList } = productInfo;
        const { checkedItemsIds } = this.state;
        const index = checkedItemsIds?.findIndex((s) => s === details?.upc);
        const freeAddonList = addOnList?.filter((obj) => obj?.sellingPrice === 0)
        const freeAddonListIndex = freeAddonList?.map((o) => { return checkedItemsIds?.findIndex((obj) => obj === o?.upc) });
        const removeIndex = freeAddonListIndex?.filter((v) => v >= 0)
        if (index === -1) {
            if (details?.sellingPrice !== 0) {
                // checkedItemsIds.splice(newD, 1);
                this.setState({ checkedItemsIds: [...checkedItemsIds, details?.upc] });
            } else {
                if (removeIndex.length > 0) {
                    checkedItemsIds.splice(removeIndex, 1);
                }
                this.setState({ checkedItemsIds: [...checkedItemsIds, details?.upc] });
            }
        } else {
            const items = [...checkedItemsIds];
            items.splice(index, 1);
            this.setState({ checkedItemsIds: items });
        }
    }
    onChangeCheck(details) {
        const { checkedIds } = this.state;
        const { excludeList } = this.props?.productInfo;
        const index = checkedIds?.findIndex((o) => {
            if (o?.baseIngredientSku === details?.baseIngredientSku && o?.substituteIngredientSku === details?.substituteIngredientSku) {
                return o
            }
        });
        let arr = []
        const data = excludeList.forEach((o) => arr.push(...o?.substitutions))
        const newData = arr?.filter((o) => o?.baseIngredientSku === details?.baseIngredientSku)
        if (index !== -1) {
            const items = [...checkedIds];
            items.splice(index, 1);
            this.setState({ checkedIds: items });
        } else {
            const newSku = newData?.map((o) => o?.substituteIngredientSku)
            const array1 = newData?.filter(val => checkedIds.find((o) => o?.baseIngredientSku === val?.baseIngredientSku && o?.substituteIngredientSku === val?.substituteIngredientSku));
            const newindex = checkedIds.findIndex((checkedId) => checkedId?.substituteIngredientSku === array1[0]?.substituteIngredientSku && checkedId?.baseIngredientSku === array1[0]?.baseIngredientSku)
            if (newindex == -1) {
                return this.setState({ checkedIds: [...checkedIds, { substituteIngredientSku: details?.substituteIngredientSku, baseIngredientSku: details?.baseIngredientSku }] })
            } else {
                const items = [...checkedIds];
                items.splice(newindex, 1);
                return this.setState({ checkedIds: [...items, { substituteIngredientSku: details?.substituteIngredientSku, baseIngredientSku: details?.baseIngredientSku }] })
            }
        }
        // const index = checkedIds?.findIndex((s) => s === details?.substituteIngredientSku);
        // if (index === -1) {
        //   // checkedIds.splice(index, 1);
        //   this.setState({ checkedIds: [...checkedIds, details?.substituteIngredientSku] });
        // } else {
        //   const items = [...checkedIds];
        //   items.splice(index, 1);
        //   this.setState({ checkedIds: items });
        // }

    }

    addOrUpdate() {
        // let sameAddon = false;
        // let sameSubtitution = false;
        // let sameBistroNotes = false;
        const { productInfo } = this.props;
        // const { checkedItemsIds, checkedIds } = this.state;
        // const filteredData = checkedIds?.map((o) => o?.substituteIngredientSku)
        // const {
        //     pimCart: { products },
        // } = this.props.getPimCartDetails;
        // const allProductsPerId = products?.filter(
        //     (data) => data.sku === productInfo.sku
        // );
        // const currentProduct = products?.find(o => productInfo?.productId === o?.productId)
        // const cartElement = allProductsPerId?.find((cartProduct) => {
        //     const addonupcs = cartProduct?.selectedAddOns?.map((ml) => ml.upc);
        //     const substitutionArray = cartProduct?.substitutionListDto
        //     if (addonupcs.length === checkedItemsIds.length && substitutionArray.length === checkedIds.length) {
        //         sameAddon = addonupcs.every((element, index) => {
        //             let sameAddonIndex = checkedItemsIds?.indexOf(element)
        //             if (sameAddonIndex !== null && sameAddonIndex !== undefined && sameAddonIndex > -1) {
        //                 return true;
        //             }
        //             return false;
        //         });
        //         sameSubtitution = substitutionArray.every((element, index) => {
        //             if (element.baseIngredientSku === checkedIds[index].baseIngredientSku && element.substituteIngredientSku === checkedIds[index].substituteIngredientSku) {
        //                 return true;
        //             }
        //             return false;
        //         });
        //     }
        //     if (sameAddon && sameSubtitution && (currentProduct?.customerInstruction === this.state.bistroNotes)) {
        //         return cartProduct
        //     }

        // });
        // if (cartElement) {
        //     this.updateItemToCart(cartElement); 
        // } else {
        //     this.addAddonsToCartItem();
        // }
        // this.addAddonsToCartItem();
        const params = {
            productSku: productInfo.sku,
            quantity: 1,
            storeId: 1,
            addOnIds: [],
            customerInstruction: this.state.bistroNotes,
            bistroProduct: true,
        };
        this.props.createPimCart(params, this.pimCartCallback);
    }

    pimCartCallback = (response) => {
        const { closeAddOnModal } = this.props
        const { response_code } = response;
        if (response_code === 0) {
            closeAddOnModal();
        } else {
            toast.error(response?.response_message, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };


    addAddonsToCartItem() {
        let excludeAndIncludeItems = []
        const { productInfo } = this.props;
        const { checkedIds, checkedItemsIds } = this.state;
        const productExcludeList = productInfo?.excludeList?.map(item => {
            checkedIds.map((obj) => {
                item.substitutions.map(subListobj => {
                    if (obj?.baseIngredientSku === subListobj?.baseIngredientSku && obj?.substituteIngredientSku === subListobj?.substituteIngredientSku) {
                        excludeAndIncludeItems.push({
                            substituteIngredientSku: subListobj?.substituteIngredientSku,
                            baseIngredientSku: subListobj?.baseIngredientSku,
                        });
                    }
                })

            });
        })
        const params = {
            bistroProduct: true,
            productSku: productInfo?.sku,
            storeId: 1,
            quantity: 1,
            addOnIds: checkedItemsIds ? checkedItemsIds : [],
            excludeAndIncludeItems: excludeAndIncludeItems ? excludeAndIncludeItems : [],
            customerInstruction: this.state.bistroNotes
        };

        this.props.createPimCart(params, this.pimCartCallback);
    }

    updateItemToCart(cartElement) {
        let params = {
            bistroProduct: true,
            cartItemId: cartElement?.cartItemId,
            storeId: 1,
            quantity: cartElement?.quantity + 1,
            addOnIds: [],
            excludeAndIncludeItems: [],
            customerInstruction: this.state.bistroNotes
        };
        this.props.updatePimCart(params, this.pimCartCallback);
    }

    _totalAmount() {
        const { checkedItemsIds, checkedIds } = this.state;
        const { productInfo } = this.props;
        const { addOnList, sellingPrice, excludeList = [] } = productInfo;
        const totalExculed = checkedIds.map((obj) => {
            return excludeList?.reduce((prev, curr) => {
                const newcurrentObj = curr?.substitutions.find((f) => obj?.baseIngredientSku === f?.baseIngredientSku && obj?.substituteIngredientSku === f?.substituteIngredientSku)
                if (!newcurrentObj?.price) return prev + 0;
                else return prev + newcurrentObj?.price;
            }, 0)
        })
        const totalExculedCost = totalExculed.reduce((a, b) => a + b, 0)
        // const coun = checkedIds.reduce((prev, curr) => {
        //   const data = excludeList?.map((obj) => {
        //     newcurrentObj = obj?.substitutions.find((f) => f.substituteIngredientSku === curr)
        //   })
        //   return prev + newcurrentObj?.price ?? 0 

        // }, 0);
        const count = checkedItemsIds.reduce((prev, curr) => {
            const currentObj = addOnList?.find((f) => f.upc === curr);
            if (currentObj?.sellingPrice === 0) return prev;
            else return prev + currentObj?.sellingPrice;
        }, 0);
        const totalCost = count + sellingPrice + Number(totalExculedCost ?? 0)
        return totalCost?.toFixed(2);
    }
    render() {
        const { closeAddOnModal, productInfo } = this.props;
        const { addOnList, excludeList = [], hasAddOns, hasExcludes } = cloneDeep(
            productInfo || {}
        );
        return (
            <ModalPopup isAddon={true} onCloseModal={closeAddOnModal}>
                <div className="row align-items-center mb-4 pb-3 border-bottom">
                    <div className="col-auto">
                        <img
                            alt="images"
                            height="60px"
                            src={
                                productInfo.imageUrl
                                    ? productInfo.imageUrl + '?$' + getRandomNumber()
                                    : Placeholder
                            }
                        />
                    </div>
                    <div className="col font16 fw-bold">
                        Customize {productInfo?.productName}
                    </div>
                </div>
                <>
                    <div className="ScrollStyle">
                        <div style={{ width: '80%' }}>
                            <div class="form-floating mb-3">
                                <input type="text" maxLength={200} className="form-control form_custom" onChange={(e) => this.setState({ bistroNotes: e.target.value })} id="floatingInput" placeholder="Enter bistro notes here" />
                                <label for="floatingInput">Customer Instructions</label>
                            </div>
                        </div>
                    </div>
                </>
                <div className="text-center pt-5 mb-3">
                    <button
                        type="button"
                        className="btn btn-dark big-btn w-100 px-5 text-uppercase"
                        onClick={() => this.addOrUpdate()}
                    >
                        Add Items <strong>${this._totalAmount()}</strong>
                    </button>
                </div>
            </ModalPopup>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getFoodProductList: Actions.getFoodProductList(state),
        getPimCartDetails: Actions.getPimCartDetails(state),
    };
};
export default withRouter(
    connect(mapStateToProps, {
        createPimCart: Actions.createPimCart,
        updatePimCart: Actions.updatePimCart,
        saveBistroNotes: Actions.bistroNotesSuccess,
    })(customerInstructionPopup)
);